import { Component, OnInit, Injector, ViewChild } from '@angular/core';
import { EditComponentModel } from '@app/shared/model/edit-component-model';
import { AnchorItem } from '@product/shared/models/AnchorItem';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.less'],
})
export class EditComponent extends EditComponentModel implements OnInit {
  @ViewChild('formComponent') formComponent: any;
  anchorItems: AnchorItem[] = [];
  editMode: string = '';
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {}

  getEditSuccessfullyMessage(record: any) {
    return 'Operation completed successfully';
  }

  setAnchorItems(anchorItems: AnchorItem[]) {
    if (anchorItems == null || anchorItems.length == 0) {
      return;
    }

    anchorItems.forEach((item) => {
      const existedItem = this.anchorItems.find((x) => x.code == item.code);
      if (existedItem != null) {
        return;
      } else {
        this.anchorItems.push(item);
      }
    });
  }

  recordDetailsLoaded() {
    this.componentModel.breadCrumbPath[
      this.componentModel.breadCrumbPath.length - 1
    ].label = `#${this.record.Id}`;
    this.componentModel.pageTitle =
      this.componentModel.endPoint + `: #${this.record.Id}`;

   
    try {
      setTimeout(() => {
        this.formComponent.recordLoaded(this.record);
      }, 0);
    } catch {}
  }

  cleanRecord(record: any) : any {
    return this.formComponent.cleanRecord(record);
  }

  beforeSubmit(): void {
    return this.formComponent.beforeSubmit();
  }

  afterSubmit(record: any): void {
    if (
      this.formComponent.afterSubmit != null &&
      typeof this.formComponent.afterSubmit == 'function'
    ) {
      this.formComponent.afterSubmit(record);
    }
  }

  submitTranslation(): void {
    this.formComponent.submitTranslation();
  }
}
